import { useEffect, useRef } from 'react';
import { FiAlertCircle, FiCheckCircle, FiClock } from 'react-icons/fi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useProductContext } from '../product/context/ProductContext.tsx';
import { ROUTE_NAME_OPTIONS } from '../utils/constants.ts';
import './order-confirmation.scss';

const OrderConfirmation = () => {
  const { setShoppingCart } = useProductContext();

  const navigate = useNavigate();
  const location = useLocation();
  const hasShownToast = useRef(false);

  const query = new URLSearchParams(location.search);
  const status = query.get('status');

  useEffect(() => {
    if (hasShownToast.current || !status) return;
    hasShownToast.current = true;

    if (status === 'approved' || status === 'pending') {
      localStorage.removeItem('shoppingCart');
      setShoppingCart({ items: [], totalItems: 0, totalPrice: 0 });
    }
  }, []);

  const config = {
    approved: {
      icon: <FiCheckCircle />,
      iconClass: 'order-confirmation-icon--success',
      title: '¡Gracias por tu compra!',
      subtitle:
        'Tu pedido fue confirmado con éxito.\nVas a recibir un mail con los detalles.',
    },
    pending: {
      icon: <FiClock />,
      iconClass: 'order-confirmation-icon--pending',
      title: 'Pago pendiente',
      subtitle:
        'Tu pedido fue registrado pero el pago aún no fue confirmado.\nTe avisaremos por correo apenas se acredite.',
    },
    failure: {
      icon: <FiAlertCircle />,
      iconClass: 'order-confirmation-icon--failure',
      title: 'Hubo un problema con el pago',
      subtitle:
        'No pudimos procesar tu pago.\nPodés volver a intentarlo desde el carrito.',
    },
  }[status ?? ''] ?? {
    icon: <FiAlertCircle />,
    iconClass: 'order-confirmation-icon--failure',
    title: 'Estado desconocido',
    subtitle: 'No pudimos determinar el estado de tu pedido.',
  };

  return (
    <div className="order-confirmation-page">
      <div className="order-confirmation-card">
        <div className={`order-confirmation-icon ${config.iconClass}`}>
          {config.icon}
        </div>
        <h2 className="order-confirmation-title">{config.title}</h2>
        <p
          className="order-confirmation-subtitle"
          style={{ whiteSpace: 'pre-line' }}
        >
          {config.subtitle}
        </p>
        <div className="order-confirmation-actions">
          <button className="primary-button" onClick={() => navigate('/')}>
            Volver al inicio
          </button>
          <button
            className="primary-button"
            onClick={() => navigate(`/${ROUTE_NAME_OPTIONS.ORDERS}`)}
          >
            Ver mis pedidos
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
